import type { ReactElement } from 'react';

export const Dice4 = (): ReactElement => {
    return (
        <>
            <g transform="scale(40) translate(0, -24)">
                <path d="M13,0a2.962,2.962,0,0,1,1.419,1.036L24,15.236,13,24ZM11,0A2.962,2.962,0,0,0,9.581,1.036L0,15.236,11,24Z" />
            </g>
            <title>dice 4</title>
        </>
    );
};
